import { Iparticle } from '@typings/setting/particle.interface';
import React from 'react';
import Particles from 'react-tsparticles';

type particleProps = {
  zIndex?: number;
  options: Iparticle;
};

function ParticleEffect({ zIndex, options }: particleProps) {
  return (
    <Particles
      style={{
        position: 'fixed',
        width: '100vw',
        height: '100vh',
        filter: 'drop-shadow(0 0 4px rgba(255, 255, 255, 0.8))',
        pointerEvents: 'none', // 모든 마우스 이벤트 차단
      }}
      options={{
        fullScreen: {
          enable: true,
          zIndex: zIndex || -1,
        },
        fpsLimit: 60,
        detectRetina: true,
        particles: {
          number: {
            value: options.number,
            limit: 300,
            density: {
              enable: true,
              value_area: 800,
            },
          },
          color: {
            value: options.color,
          },
          shape: {
            type: options.shapeImageURL ? 'image' : 'circle',
            stroke: {
              width: 0,
              color: '#000000',
            },
            polygon: {
              nb_sides: 5,
            },
            image: {
              src: options.shapeImageURL,
              width: 100,
              height: 100,
            },
          },
          opacity: {
            value: 0.5,
            random: true,
            anim: {
              enable: true,
              speed: 1,
              opacity_min: 0.5,
              sync: false,
            },
          },
          size: {
            value: Number(options.size),
            random: true,
            anim: {
              enable: true,
              speed: 40,
              size_min: 0.1,
              sync: false,
            },
          },
          line_linked: {
            enable: options.lineLinked || false,
            distance: Number(options.distance) || 40,
            color: options.color,
            opacity: 0.4,
            width: 2,
          },
          move: {
            enable: true,
            speed: Number(options.speed),
            direction: options.direction,
            random: false,
            straight: false,
            out_mode: 'out',
            bounce: false,
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200,
            },
          },
        },
        interactivity: {
          detect_on: 'window', // canvas에서 window로 변경
          events: {
            onHover: {
              enable: false,
              mode: 'bubble',
              parallax: {
                enable: false,
                force: 60,
                smooth: 10,
              },
            },
            onClick: {
              enable: false,
              mode: 'repulse',
            },
            resize: true,
          },
          modes: {
            grab: {
              distance: 0,
              lineLinked: {
                opacity: 0,
              },
            },
            bubble: {
              distance: 0,
              size: 0,
              duration: 0,
              opacity: 0,
            },
            repulse: {
              distance: 0,
            },
            push: {
              particles_nb: 0,
            },
            remove: {
              particles_nb: 0,
            },
          },
        },
        backgroundMask: {
          enable: false,
        },
        retina_detect: true,
        fps_limit: 60,
        background: {
          image: '',
        },
      }}
    />
  );
}

export default ParticleEffect;
